import { render, staticRenderFns } from "./RoomExam.vue?vue&type=template&id=8df298d2&scoped=true&"
import script from "./RoomExam.vue?vue&type=script&lang=js&"
export * from "./RoomExam.vue?vue&type=script&lang=js&"
import style0 from "./RoomExam.vue?vue&type=style&index=0&id=8df298d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df298d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8df298d2')) {
      api.createRecord('8df298d2', component.options)
    } else {
      api.reload('8df298d2', component.options)
    }
    module.hot.accept("./RoomExam.vue?vue&type=template&id=8df298d2&scoped=true&", function () {
      api.rerender('8df298d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Testbank/View/RoomExam.vue"
export default component.exports